import Heading from "./Heading";
import ThemedSkeleton from "./ThemedSkeleton";

export default function AppSkeleton() {
  return (
    <>
      <Heading as="h1">
        <ThemedSkeleton />
      </Heading>
      <ThemedSkeleton className="h-[125px] w-5/6 rounded-xl" />

      <div className="flex flex-col space-y-4">
        <Heading as="h2" className="w-5/6">
          <ThemedSkeleton />
        </Heading>
        <Heading as="h3" className="w-3/6">
          <ThemedSkeleton />
        </Heading>
        <ThemedSkeleton className="w-4/6" />
      </div>
    </>
  );
}
